import { cn } from "@/lib/utils";

export interface HotelinkingLogoProps {
  /** Rendered height of the square mark in px; the wordmark scales with it. */
  height?: number;
  className?: string;
}

/**
 * The Hotelinking isotype (signal arcs over a ring) in its rounded square,
 * beside the "Hotelinking" wordmark and an "Admin Console" label — the same
 * lockup as the admin sidebar header. The three glyph paths are copied
 * verbatim from admin's `components/brand/hotelinking-mark.tsx` (itself lifted
 * from the brand asset); never hand-edit them. Colours come from admin.css.
 */
export function HotelinkingLogo({
  height = 32,
  className,
}: HotelinkingLogoProps) {
  return (
    <span
      role="img"
      aria-label="Hotelinking Admin"
      className={cn("hl-logo", className)}
      style={{ fontSize: height / 2 }}
    >
      <span className="hl-logo__square" style={{ width: height, height }}>
        <HotelinkingMark className="hl-logo__mark" />
      </span>
      <span className="hl-logo__text">
        <span className="hl-logo__word">Hotelinking</span>
        <span className="hl-logo__sub">Admin Console</span>
      </span>
    </span>
  );
}

export function HotelinkingMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 50 50"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        className="hl-mark__ring"
        d="M16.3 33.59C16.3 28.52 20.22 24.6 25.14 24.6C30.06 24.6 34.01 28.52 34.01 33.59C34.01 38.66 30.06 42.58 25.14 42.58C20.22 42.58 16.3 38.66 16.3 33.59ZM29.6901 33.59C29.6901 30.83 27.72 28.89 25.14 28.89C22.56 28.89 20.6201 30.83 20.6201 33.59C20.6201 36.35 22.59 38.29 25.14 38.29C27.69 38.29 29.6901 36.35 29.6901 33.59Z"
      />
      <path
        className="hl-mark__arc hl-mark__arc--inner"
        d="M31.44 17.75L28.38 20.86C26.31 19.97 23.7 19.95 21.62 20.81L18.56 17.69C22.53 15.56 27.5 15.59 31.44 17.75Z"
      />
      <path
        className="hl-mark__arc hl-mark__arc--outer"
        d="M37.85 11.12L34.78 14.24C29.23 10.85 20.77 10.85 15.22 14.24L12.15 11.12C19.1 6.18999 30.89 6.18999 37.85 11.12Z"
      />
    </svg>
  );
}
